import React, { useState, useContext, useEffect } from "react"
import blogFetch from "../../axios/config";
import Context from "../../context/Context";
import Button from "@mui/material/Button";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import toast from "react-hot-toast";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Pagination,
} from "@mui/material";
import language from "../../nls/language.json";
import { ExpandMore } from "@mui/icons-material";
import { AddCombinationsModal, EditCombinationsModal } from "./modals";
import './Combinations.css';

const INITIAL_ADD_COMBINATION = {
  tipoCombinacao: {
    aproveitamento: 1,
    ativo: true,
    comb_Nome: "",
    forno: "",
    DifBomba: 0
  },
  combinacao: [{
    grupo_produto: "",
    grupo_peca: ""
  }]
};

const MAX_PIECE = 15;
const GRUPO_PECA = "GRUPO_PECA";
const GRUPO_PECA_BY_ITEM = "GRUPO_PECA_BY_ITEM";

export default function CombinationsTable() {
  const [showModalAdd, setShowModalAdd] = useState(false);
  const [ShowModalEdit, setShowModalEdit] = useState(false);

  const [selectedCombination, setSelectedCombination] = useState({})
  const [selectedAddCombination, setSelectedAddCombination] = useState(INITIAL_ADD_COMBINATION)
  const [combinations, SetGetCombinations] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState();
  const [qtPiece, setQtPiece] = useState(1);
  const [grupoPecas, setGrupoPecas] = useState([]);
  const [grupoProdutos, setGrupoProdutos] = useState([]);

  const {
    selectedCountry,
    getFurnace,
  } = useContext(Context);

  useEffect(() => {
    getCombinations();
    getGrupoPecas();
    getGrupoProduto();
  }, [currentPage])

  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const getCombinations = async () => {
    try {
      const skip = (currentPage - 1) * rowsPerPage;
      const take = rowsPerPage;
      const { data } = await blogFetch.get(`/ISAGA_TipoCombinacoesPecas?skip=${skip}&take=${take}`);

      SetGetCombinations(data)
      // Se retornou exatamente 'take' itens, pode haver mais páginas
      if (data.length === take) {
        setTotalPages(currentPage + 1);
      } else {
        setTotalPages(currentPage);
      }
    } catch (error) {
      console.error(error);
    }
  }

  const postCombination = async (data) => {
    try {
      await blogFetch.post('/ISAGA_CombinacoesPecas/create/combinations', data);

      setShowModalAdd(false);
      getCombinations();
      toast.success(language[selectedCountry.name].Cadastro.combinacoes.notification.successAdd, {
        duration: 4000,
      });
    } catch (error) {
      console.error(error);
      toast.error(language[selectedCountry.name].Cadastro.combinacoes.notification.errorAdd, {
        duration: 4000,
      });
    }
  }

  const getGrupoProduto = async () => {
    try {
      const { data } = await blogFetch.get(`/ISAGA_TipoProdutoGrupo/grupoNome`);
      setGrupoProdutos(data);
    } catch (error) {
      console.error(error);
    }
  }

  const getGrupoPecas = async () => {
    try {
      const { data } = await blogFetch.get(`/ISAGA_TipoPecaGrupo/grupoNome`);
      setGrupoPecas(data);
    } catch (error) {
      console.error(error);
    }
  }

  const putCombination = async (data) => {
    try {
      await blogFetch.put(`/ISAGA_TipoCombinacoesPecas`, data);
      toast.success(language[selectedCountry.name].Cadastro.combinacoes.notification.successUpdate, {
        duration: 4000,
      });
      getCombinations();
      setShowModalEdit(false);
    } catch (error) {
      console.error(error);
      toast.error(language[selectedCountry.name].Cadastro.combinacoes.notification.errorUpdate, {
        duration: 4000,
      });
    }
  }

  const handleSelectedAddCombination = () => {
    setQtPiece(1);
    setSelectedAddCombination(INITIAL_ADD_COMBINATION);
    setShowModalAdd(true);
  }

  const handleSelectedCombination = (data) => {
    setSelectedCombination(data);
    setShowModalEdit(true);
  }

  const handleAddCombinacoes = ({ name, value }, type, index) => {
    switch (type) {
      case GRUPO_PECA:
        setSelectedAddCombination({
          ...selectedAddCombination,
          combinacao: [...Array(value)]
        });
        break;
      case GRUPO_PECA_BY_ITEM:
        setSelectedAddCombination({
          ...selectedAddCombination,
          combinacao: selectedAddCombination.combinacao.map((item, i) => {
            if (i === index) {
              item = {
                ...item,
                [name]: value
              };
            }

            return item
          })
        });
        break;
      default:
        setSelectedAddCombination({
          ...selectedAddCombination,
          tipoCombinacao: {
            ...selectedAddCombination.tipoCombinacao,
            [name]: value
          }
        });
        break;
    }
  }

  const checkSaveBtn = (data) => !data.every(item => item?.grupo_produto && item?.grupo_peca);

  return (
    <>
      <div>
        <div className="header_tables_view">
          <div></div>
          <div>
            <h3 className="title_tables">
              {language[selectedCountry.name].Cadastro.combinacoes.title}
            </h3>
          </div>
          <div>
            <Button
              className="btn add_button"
              variant="primary"
              onClick={() => handleSelectedAddCombination()}
            >
              {language[selectedCountry.name].Cadastro.combinacoes.btnAdicionar}
            </Button>
          </div>
        </div>
        {combinations.map((item, i) => (
          <Accordion key={`comb-${i}`}>
            <AccordionSummary
              expandIcon={<ExpandMore />}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
              className="header-flex accordionSummary"
            >
              <p className="forno-text">{item.comb_Nome}</p>
              <p className="me-3">{item.forno}</p>
              <span className={`comb-badge ${item.ativo ? "comb-badge-ativo" : "comb-badge-inativo"}`}>
                {item.ativo ? "ATIVO" : "INATIVO"}
              </span>
              <span className="comb-badge-count ms-2">
                {item.isagA_Combinacoes_Pecas?.length || 0} peças
              </span>
            </AccordionSummary>
            <AccordionDetails>
              <table className="table table-hover">
                <thead className="table-header">
                  <tr className="table_row">
                    <th>{language[selectedCountry.name].Cadastro.combinacoes.tableHeader.nome}</th>
                    <th>{language[selectedCountry.name].Cadastro.combinacoes.tableHeader.ativo}</th>
                    <th>{language[selectedCountry.name].Cadastro.combinacoes.tableHeader.aproveitamento}</th>
                    <th>Bomba</th>
                    <th className="edit">
                      <center>
                        <ModeEditIcon
                          color="info"
                          onClick={() => handleSelectedCombination(item)}
                        />
                      </center>
                    </th>
                  </tr>
                </thead>
                <tbody className="table_row">
                  {item.isagA_Combinacoes_Pecas?.map((itemComb, indexItemComb) => (
                    <tr key={`combinations-table-${indexItemComb}`}>
                      <td>{`${itemComb.grupo_Peca} - ${itemComb.grupo_Produto}`}</td>
                      <td>{item.ativo ? "ATIVO" : "INATIVO"}</td>
                      <td>{item.aproveitamento}</td>
                      <td>{item.difBomba}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </AccordionDetails>
          </Accordion>
        ))}
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={handlePageChange}
          shape="rounded"
        />
      </div>
      <AddCombinationsModal
        showModalAdd={showModalAdd}
        setShowModalAdd={setShowModalAdd}
        handleAddCombinacoes={handleAddCombinacoes}
        setQtPiece={setQtPiece}
        MAX_PIECE={MAX_PIECE}
        selectedAddCombination={selectedAddCombination}
        grupoPecas={grupoPecas}
        grupoProdutos={grupoProdutos}
        postCombination={postCombination}
        checkSaveBtn={checkSaveBtn}
        qtPiece={qtPiece}
      />
      <EditCombinationsModal
        ShowModalEdit={ShowModalEdit}
        setShowModalEdit={setShowModalEdit}
        selectedCombination={selectedCombination}
        setSelectedCombination={setSelectedCombination}
        putCombination={putCombination}
        grupoPecas={grupoPecas}
        grupoProdutos={grupoProdutos}
      />
    </>
  )
}

